import * as yup from 'yup';

const errorMessages = {
 required: 'Campo obrigatório',
};

/**
 * EG-42/AD-2 — schema da CRIAÇÃO invertida do periódico.
 *
 * `form` (pilares com temas e perguntas) deixou de ser campo de formulário e
 * virou estrutura derivada dos templates. Exigi-lo mantinha isValid falso e o
 * Finalizar desabilitado para sempre.
 *
 * "Tem pelo menos uma pergunta" é checado pela tela, contra a seleção de
 * templates — não cabe no schema porque o dado não está no formulário.
 */
export const periodicCreateSchema = yup.object().shape({
 name: yup.string().required(errorMessages.required),
 startDeadline: yup.date().required(errorMessages.required),
 endDeadline: yup.date().when('noEndDeadline', {
  is: (val) => val === false,
  then: (schema) => schema.required(errorMessages.required),
  otherwise: (schema) => schema.nullable(),
 }),
 noEndDeadline: yup.boolean().default(false),
});

/**
 * EG-42 — schema da EDIÇÃO de periódico.
 *
 * Mesma decisão do certificado: a estrutura vem do template. Saíram o "Número de
 * pilares" e o seletor de pilar, então o schema deixa de exigir pillarName,
 * numberOfThemes e a igualdade entre themes.length e numberOfThemes — regras que
 * descreviam um formulário que a tela não tem mais.
 */
export const periodicEditSchema = yup.object().shape({
 name: yup.string().required(errorMessages.required),
 startDeadline: yup.date().required(errorMessages.required),
 endDeadline: yup.date().when('noEndDeadline', {
  is: (val) => val === false,
  then: (schema) => schema.required(errorMessages.required),
  otherwise: (schema) => schema.nullable(),
 }),
 noEndDeadline: yup.boolean().default(false),
});

// EG-42 — periodicSchema e periodicSchemaUpdate REMOVIDOS, e com eles toda a
// cadeia que só existia para alimentá-los: createPeriodicSchema, basicSchema,
// newFieldSchema, schemaWithNewField, themeSchema e numberOfThemesOptions.
//
// Eles validavam pillarName, numberOfThemes e a igualdade themes.length ===
// numberOfThemes. Os três campos saíram da tela: pillarName na EG-40 (o nome do
// pilar passou a vir do catálogo) e os outros dois na decisão D7 desta story.
//
// O motivo de deletar em vez de deixar: um schema que exige campo inexistente
// mantém isValid falso e o botão Finalizar desabilitado — foi exatamente esse o
// defeito que travou a edição de periódico e de certificado. Deixá-los vivos
// convida o próximo dev a religá-los no resolver e reproduzir a trava, com o
// agravante de que o comentário deste arquivo os declarava "intactos porque
// Periodic/Edit/Form.jsx depende", o que deixou de ser verdade quando a tela foi
// reescrita nesta mesma story.
